module.exports = __webpack_public_path__ + "img/m.508b3d68.jpg";